import { IValidateCustomerDocumentDTO } from 'modules/authentication/domain/dtos';
import { IValidateCustomerDocumentRepository } from 'modules/authentication/domain/repositories';

export class ValidateCustomerDocumentUseCase {
  constructor(
    private validateCustomerDocumentRepository: IValidateCustomerDocumentRepository,
  ) {}

  public async execute({ document }: IValidateCustomerDocumentDTO) {
    return this.validateCustomerDocumentRepository.validate(document);
  }
}
